/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonStorageUploadFromJSON, InternalCommonStorageUploadToJSON, } from './InternalCommonStorageUpload';
import { InternalCommonCommentableTypesFromJSON, InternalCommonCommentableTypesToJSON, } from './InternalCommonCommentableTypes';
/**
 * Check if a given object implements the InternalCommonCommentBase interface.
 */
export function instanceOfInternalCommonCommentBase(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('parentType' in value) || value['parentType'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    return true;
}
export function InternalCommonCommentBaseFromJSON(json) {
    return InternalCommonCommentBaseFromJSONTyped(json, false);
}
export function InternalCommonCommentBaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'content': json['content'],
        'parentType': InternalCommonCommentableTypesFromJSON(json['parent_type']),
        'parentId': json['parent_id'],
        'uploads': json['uploads'] == null ? undefined : (json['uploads'].map(InternalCommonStorageUploadFromJSON)),
        'attachments': json['attachments'] == null ? undefined : (json['attachments'].map(InternalCommonStorageUploadFromJSON)),
    };
}
export function InternalCommonCommentBaseToJSON(json) {
    return InternalCommonCommentBaseToJSONTyped(json, false);
}
export function InternalCommonCommentBaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'parent_type': InternalCommonCommentableTypesToJSON(value['parentType']),
        'parent_id': value['parentId'],
        'uploads': value['uploads'] == null ? undefined : (value['uploads'].map(InternalCommonStorageUploadToJSON)),
        'attachments': value['attachments'] == null ? undefined : (value['attachments'].map(InternalCommonStorageUploadToJSON)),
    };
}
